// extracted by mini-css-extract-plugin
export var black = "#181818";
export var blackHSL = "0 0% 9%";
export var desktopWidth = "960px";
export var lgBreakpoint = "60rem";
export var mdBreakpoint = "40rem";
export var white = "#fcfcfc";
export var whiteHSL = "0 0% 99%";